import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";
import { useHistory } from 'react-router-dom';

import { Header, BrokerDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditBroker = withRouter(props => {

  const classes = useStyles();
  const [productobj , setProductobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const history = useHistory();

  const [masters, setMasters] = useState({
    commodity :[]
  });
  const snackbarCtx = React.useContext(SnackBarContext);

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    let storeproduct = await sendNetworkRequest('/admin/getactivestoreproducts', {}, {},false)
    setMasters({
      ...masters,
      languages : [ {
        id: 0,
        name : "All"
      },
      ...languages.module
     ],
      commodity : commodities.module,
      products : storeproduct.module
    })
  }
  async function updateproductinfo(productdetails)
  {
    let prodinfo = await sendNetworkRequest('/admin/addbroker', {},   productdetails,false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: prodinfo.status,
      msg: prodinfo.message,
      vertical: "top",
    });

    history.push("/brokers");
  }
  async function fetchproductinfo(prodid)
  {
    let prodinfo = await sendNetworkRequest('/admin/getbrokerinfo', {}, {broker_id : prodid},false)
    let broker = {
      ...prodinfo.module
     }

   let prodlanguages = [];
   let prodlanguageids = broker.languages

   if(masters && masters.languages)
   {
   masters.languages.forEach(element => {
    if(prodlanguageids)
    {
      if(prodlanguageids.includes(""+element?.id))
      {
       prodlanguages.push(element)
      }
    }
  
   });
   
   broker['languages'] = prodlanguages

 }
 let bro_products = prodinfo?.module?.broker_products;
   let brok_products = []
   if(bro_products)
   {
    bro_products.map(prod => {
      brok_products.push(prod.master_store_product)
    })
    broker['products'] = brok_products
   }
   
    setProductobj({
      ...broker,
      brokers_name : broker.name,
      gst_number: broker.gst_no
      
    })
  }
  useEffect(() => {
    var product_id = props.location.pathname.split('/')[2];
   // var viewtype = props.location.pathname.split('/')[3];
    setViewtype(2)
   // setUserid(user_id)
   if(product_id)
   {
     fetchproductinfo(product_id);
   }
   
 }, [masters]);
  useEffect(() => {
     var product_id = props.location.pathname.split('/')[2];
    // var viewtype = props.location.pathname.split('/')[3];
     setViewtype(1)
    // setUserid(user_id)
    if(product_id)
    {
      setViewtype(1)
    //  fetchproductinfo(product_id);
    }
    
    fetchmasters()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Broker"
    >
      <Header />
     <BrokerDetails usercontent={productobj} masters={masters} viewtype={viewtype} onUpdate={updateproductinfo}/>  
     
    </Page>
  );
});

export default EditBroker;
